import { FC } from 'react';
import classnames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { Header } from 'dibs-elements/exports/Header';
import CircleCheck from 'dibs-icons/exports/legacy/CircleCheck';

import IFramedPromoPartnershipStartShoppingCta from './IFramedPromoPartnershipStartShoppingCta';

import styles from './styles/IFramedPromoPartnershipFormSubmitted.scss';
import sharedStyles from './styles/shared.scss';

type Props = {
    promoCode: string;
};

const IFramedPromoPartnershipFormSubmitted: FC<Props> = ({ promoCode }) => (
    <HeadingLevel>
        {Heading => (
            <div className={classnames(sharedStyles.wrapper, sharedStyles.wrapperSpacing)}>
                <Header
                    htmlElementType={Heading}
                    title={
                        <span className={styles.titleWrapper}>
                            <span className={styles.icon}>
                                <CircleCheck />
                            </span>
                            <FormattedMessage
                                id="iFramedpromoPartnership.IFramedPromoPartnershipFormSubmitted.title"
                                defaultMessage="Thank you for submitting"
                            />
                        </span>
                    }
                />
                {promoCode && (
                    <p className={styles.text}>
                        <FormattedMessage
                            id="iFramedpromoPartnership.IFramedPromoPartnershipFormSubmitted.text"
                            defaultMessage="Your Promo Code: {promoCode}"
                            values={{
                                promoCode: <span className={styles.promoCode}>{promoCode}</span>,
                            }}
                        />
                    </p>
                )}
                <IFramedPromoPartnershipStartShoppingCta />
            </div>
        )}
    </HeadingLevel>
);

export default IFramedPromoPartnershipFormSubmitted;
